var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","items":_vm.labels,"chips":"","loading":_vm.loadingImages,"label":"Filter by Labels","multiple":"","id":"filter-by-labels","single-line":"","clearable":""},on:{"input":_vm.filterByFaultTypes},model:{value:(_vm.selectedLabels),callback:function ($$v) {_vm.selectedLabels=$$v},expression:"selectedLabels"}})
}
var staticRenderFns = []

export { render, staticRenderFns }